import { render, staticRenderFns } from "./VehicleTypesView.vue?vue&type=template&id=9a64c7b4&"
import script from "./VehicleTypesView.vue?vue&type=script&lang=ts&"
export * from "./VehicleTypesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports